module.exports = __webpack_public_path__ + "static/media/history_21.ef862642.jpg";